import {
	cardTitleProps,
	tdProps,
	thProps,
	tableDescriptionProps,
} from '../../common';
import {
	courseImg,
	courseImg2,
	courseImg3,
	courseImg4,
	heightmap,
} from '../../../config/images';

import {colorPalette} from '../../../config';

// export const imageProps = {
// 	src: courseImg,
// 	alt: '코스',
// 	borderRadius: '1.375rem',
// 	border: `1px solid ${colorPalette.border}`,
// };
// export const imagePropsTitle = {
// 	title: {
// 		text: {children: '대회코스', ...cardTitleProps},
// 	},
// };
export const imageProps = {
	title0: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '고저도', ...cardTitleProps, type: 'p'},
	},
	course0: {
		src: heightmap,
		alt: '고저도',
		borderRadius: '1.375rem',
	},
	title: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '풀코스', ...cardTitleProps, type: 'p'},
	},
	course: {
		src: courseImg,
		alt: '풀코스',
		borderRadius: '1.375rem',
	},
	title2: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '하프코스', ...cardTitleProps, type: 'p'},
	},
	course2: {
		src: courseImg2,
		alt: '하프코스',
		borderRadius: '1.375rem',
	},
	title3: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '10.19km', ...cardTitleProps, type: 'p'},
	},
	course3: {
		src: courseImg3,
		alt: '10.19km',
		borderRadius: '1.375rem',
	},
	title4: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '5km', ...cardTitleProps, type: 'p'},
	},
	course4: {
		src: courseImg4,
		alt: '5km',
		borderRadius: '1.375rem',
	},
	title5: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '코스', ...cardTitleProps, type: 'p'},
	},
	course5: {
		src: courseImg,
		alt: '코스',
		borderRadius: '1.375rem',
	},
	title6: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '5km', ...cardTitleProps, type: 'p'},
	},
	title7: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '10.19km', ...cardTitleProps, type: 'p'},
	},
};

export const limitTime = {
	title: {
		text: {children: '대회 코스 통제 시간', ...cardTitleProps},
	},
	table: {
		// ths: [
		// 	{...thProps, children: '종목'},
		// 	{...thProps, children: '출발시간'},
		// 	{...thProps, children: '경기종료'},
		// 	{...thProps, children: '제한시간'},
		// ],
		// trs: [
		// 	[
		// 		{...tdProps, children: '풀코스'},
		// 		{...tdProps, children: '09:30'},
		// 		{...tdProps, children: '14:30'},
		// 		{...tdProps, children: '5시간'},
		// 	],
		// 	[
		// 		{...tdProps, children: '하프코스'},
		// 		{...tdProps, children: '09:40'},
		// 		{...tdProps, children: '12:40'},
		// 		{...tdProps, children: '3시간'},
		// 	],
		// 	[
		// 		{...tdProps, children: '10.19km'},
		// 		{...tdProps, children: '09:50'},
		// 		{...tdProps, children: '11:50'},
		// 		{...tdProps, children: '2시간'},
		// 	],
		// 	[
		// 		{...tdProps, children: '5km'},
		// 		{...tdProps, children: '09:55'},
		// 		{...tdProps, children: '10:55'},
		// 		{...tdProps, children: '1시간'},
		// 	],
		// ],
		ths: [
			{...thProps, children: '구간'},
			{...thProps, children: '시간'},
			{...thProps, children: '내용'},
		],
		trs: [
			[
				{...tdProps, children: '동천 자전거도로'},
				{...tdProps, children: '18:00 - 21:00'},
				{...tdProps, children: '전면 통제'},
			],
		],
		descriptions: [
			// {
			// 	content: {
			// 		...tableDescriptionProps,
			// 		children: `제한 시간이 넘었음에도 불구하고 주최 측 회송차량 승차를 거부한 채 계속 주행하던 도중에 발생하는 사고에 대한 모든 책임은 참가자 본인에게 있으며, 주최 측은 책임을 지지 않습니다.`,
			// 	},
			// },
			{
				content: {
					...tableDescriptionProps,
					children: `21시 이후에는 자전거도로 교통 통제가 해제됩니다.`,
				},
			},
		],
	},
};

export const courseTable = {
	table: {
		ths: [
			{...thProps, children: '구분'},
			{...thProps, children: '출발시간'},
			{...thProps, children: '제한시간'},
			{...thProps, children: '코스'},
		],
		trs: [
			[
				{...tdProps, children: '10.19km'},
				{...tdProps, children: '09:00'},
				{...tdProps, children: '11:00'},
				{...tdProps, children: '진남경기장~자전거도로~만흥 마래터널 왕복'},
			],
			[
				{...tdProps, children: '5km'},
				{...tdProps, children: '09:10'},
				{...tdProps, children: '10:10'},
				{...tdProps, children: '진남경기장~자전거도로~미평공원 왕복'},
			],
			[
				{
					...tdProps,
					children: '주로가 협소하므로 안전을 위해 부득이하게 휠체어, 유모차, 애견동반이 금지됩니다.',
					colSpan: 4,
				},
			],
		],
	},
};